import { Icon } from "@chakra-ui/react";
import {
  MdDashboard,
  MdHome,
  MdLock,
  MdSupervisedUserCircle,
} from "react-icons/md";

// Admin Imports
import DashboardsDefault from "./views/admin/dashboards/default";

// // NFT Imports

// Main Imports
import AccountApplications from "./views/admin/main/account/application";
import AccountBilling from "./views/admin/main/account/billing";
import AccountCoursePage from "./views/admin/main/account/coursePage";
import AccountAllCourses from "./views/admin/main/account/courses";
import AccountInvoice from "./views/admin/main/account/invoice";
import AccountSettings from "./views/admin/main/account/settings";

import UserNew from "./views/admin/main/users/newUser";
import UsersOverview from "./views/admin/main/users/overview";
import UsersReports from "./views/admin/main/users/reports";

import ProfileNewsfeed from "./views/admin/main/profile/newsfeed";
import ProfileOverview from "./views/admin/main/profile/overview";
import ProfileSettings from "./views/admin/main/profile/settings";

import ApplicationsCalendar from "./views/admin/main/applications/calendar";
import ApplicationsDataTables from "./views/admin/main/applications/dataTables";
import ApplicationsKanban from "./views/admin/main/applications/kanban";

import EcommerceNewProduct from "./views/admin/main/ecommerce/newProduct";
import EcommerceOrderDetails from "./views/admin/main/ecommerce/orderDetails";
import EcommerceOrderList from "./views/admin/main/ecommerce/orderList";
import EcommerceProductOverview from "./views/admin/main/ecommerce/overviewProduct";
import EcommerceProductPage from "./views/admin/main/ecommerce/pageProduct";
import EcommerceReferrals from "./views/admin/main/ecommerce/referrals";
import EcommerceProductSettings from "./views/admin/main/ecommerce/settingsProduct";

// Others
import OthersError from "./views/admin/main/others/404";
import Messages from "./views/admin/main/others/messages";
import OthersNotifications from "./views/admin/main/others/notifications";
import OthersPricing from "./views/admin/main/others/pricing";

// Auth Imports
import { default as Category } from "./views/admin/Category";
import { default as CategoryCreate } from "./views/admin/Category/Create";
import Group from "./views/admin/group";
import GroupCreate from "./views/admin/group/Create";
import Package from "./views/admin/package";
import PackageCreate from "./views/admin/package/Create";
import Product from "./views/admin/product";
import ProductCreate from "./views/admin/product/Create";
import Retailer from "./views/admin/retailer";
import RetailerCategory from "./views/admin/retailer-category";
import RetailerCategoryCreate from "./views/admin/retailer-category/Create";
import RetailerProduct from "./views/admin/retailer-product";
import RetailerProductCreate from "./views/admin/retailer-product/Create";
import RetailerCreate from "./views/admin/retailer/Create";
import Shipping from "./views/admin/shipping";
import ShippingCreate from "./views/admin/shipping/Create";
import SubCategory from "./views/admin/sub-category";
import SubCategoryCreate from "./views/admin/sub-category/Create";
import User from "./views/admin/user";
import UserCreate from "./views/admin/user/Create";
import ForgotPasswordCentered from "./views/auth/forgotPassword/ForgotPasswordCentered";
import ForgotPasswordDefault from "./views/auth/forgotPassword/ForgotPasswordDefault";
import LockCentered from "./views/auth/lock/LockCentered";
import LockDefault from "./views/auth/lock/LockDefault";
import SignInDefault from "./views/auth/signIn/SignInDefault";
import SignUpCentered from "./views/auth/signUp/SignUpCentered";
import SignUpDefault from "./views/auth/signUp/SignUpDefault";
import GroupProduct from "./views/admin/group-product";
import GroupProductCreate from "./views/admin/group-product/Create";
import Order from "./views/admin/order";
import OrderCreate from "./views/admin/order/Create";
import ExcelListDetails from "./views/admin/retailer-product/excel-list-details";
import ExcelList from "./views/admin/retailer-product/excel-list";
import Campaign from "./views/admin/campaign";
import CampaignCreate from "./views/admin/campaign/Create";
import CampaignNews from "./views/admin/campaign-news";
import CampaignNewsCreate from "./views/admin/campaign-news/Create";
import Store from "./views/admin/store";
import StoreCreate from "./views/admin/store/Create";
import ContactUs from "./views/admin/contact-us";
import ContactUsCreate from "./views/admin/contact-us/Create";
import ImagesUpload from "./views/admin/images-upload";

const adminRoutes = [
  {
    name: "sideBar.dashboard",
    layout: "/admin",
    visibleSidebar: true,
    path: "/dashboards",
    icon: <Icon as={MdHome} w={5} h={5} />,
    component: <DashboardsDefault />,
  },
  {
    name: "sideBar.category",
    layout: "/admin",
    visibleSidebar: true,
    path: "/category",
    icon: <Icon as={MdSupervisedUserCircle} w={5} h={5} />,
    component: <Category />,
  },
  {
    name: "sideBar.categoryCreate",
    layout: "/admin",
    visibleSidebar: false,
    path: "/category/create",
    component: <CategoryCreate />,
  },
  {
    name: "sideBar.categoryUpdate",
    layout: "/admin",
    visibleSidebar: false,
    path: "/category/create/:id",
    component: <CategoryCreate />,
  },
  {
    name: "sideBar.subCategory",
    layout: "/admin",
    visibleSidebar: true,
    path: "/sub-category",
    icon: <Icon as={MdSupervisedUserCircle} w={5} h={5} />,
    component: <SubCategory />,
  },
  {
    name: "sideBar.subCategory",
    layout: "/admin",
    visibleSidebar: false,
    path: "/sub-category/create",
    component: <SubCategoryCreate />,
  },
  {
    name: "sideBar.subCategory",
    layout: "/admin",
    visibleSidebar: false,
    path: "/sub-category/create/:id",
    component: <SubCategoryCreate />,
  },
  {
    name: "sideBar.product",
    layout: "/admin",
    path: "/product",
    visibleSidebar: true,
    icon: <Icon as={MdSupervisedUserCircle} w={5} h={5} />,
    component: <Product />,
  },
  {
    name: "sideBar.productCreate",
    layout: "/admin",
    path: "/product/create",
    visibleSidebar: false,
    component: <ProductCreate />,
  },
  {
    name: "sideBar.productUpdate",
    layout: "/admin",
    path: "/product/create/:id",
    visibleSidebar: false,
    component: <ProductCreate />,
  },
  {
    name: "sideBar.package",
    layout: "/admin",
    path: "/package",
    visibleSidebar: true,
    icon: <Icon as={MdSupervisedUserCircle} w={5} h={5} />,
    component: <Package />,
  },
  {
    name: "sideBar.packageCreate",
    layout: "/admin",
    path: "/package/create",
    visibleSidebar: false,
    component: <PackageCreate />,
  },
  {
    name: "sideBar.packageUpdate",
    layout: "/admin",
    path: "/package/create/:id",
    visibleSidebar: false,
    component: <PackageCreate />,
  },
  {
    name: "sideBar.group",
    layout: "/admin",
    path: "/groups",
    visibleSidebar: true,
    icon: <Icon as={MdSupervisedUserCircle} w={5} h={5} />,
    component: <Group />,
  },
  {
    name: "sideBar.groupCreate",
    layout: "/admin",
    path: "/groups/create",
    visibleSidebar: false,
    component: <GroupCreate />,
  },
  {
    name: "sideBar.groupUpdate",
    layout: "/admin",
    path: "/groups/create/:id",
    visibleSidebar: false,
    component: <GroupCreate />,
  },

  {
    name: "sideBar.groupProduct",
    layout: "/admin",
    path: "/group-product",
    visibleSidebar: true,
    icon: <Icon as={MdSupervisedUserCircle} w={5} h={5} />,
    component: <GroupProduct />,
  },
  {
    name: "sideBar.groupProductCreate",
    layout: "/admin",
    path: "/group-product/create",
    visibleSidebar: false,
    component: <GroupProductCreate />,
  },
  {
    name: "sideBar.groupProductUpdate",
    layout: "/admin",
    path: "/group-product/create/:id",
    visibleSidebar: false,
    component: <GroupProductCreate />,
  },

  {
    name: "sideBar.shipping",
    layout: "/admin",
    path: "/shipping",
    visibleSidebar: true,
    icon: <Icon as={MdSupervisedUserCircle} w={5} h={5} />,
    component: <Shipping />,
  },
  {
    name: "sideBar.shippingCreate",
    layout: "/admin",
    path: "/shipping/create",
    visibleSidebar: false,
    component: <ShippingCreate />,
  },
  {
    name: "sideBar.shippingUpdate",
    layout: "/admin",
    path: "/shipping/create/:id",
    visibleSidebar: false,
    component: <ShippingCreate />,
  },
  {
    name: "sideBar.order",
    layout: "/admin",
    path: "/order",
    visibleSidebar: true,
    icon: <Icon as={MdSupervisedUserCircle} w={5} h={5} />,
    component: <Order />,
  },
  {
    name: "sideBar.order",
    layout: "/admin",
    path: "/order/create/:id",
    visibleSidebar: false,
    component: <OrderCreate />,
  },
  {
    name: "sideBar.user",
    layout: "/admin",
    visibleSidebar: true,
    path: "/user",
    icon: <Icon as={MdSupervisedUserCircle} w={5} h={5} />,
    component: <User />,
  },
  {
    name: "sideBar.campaign",
    layout: "/admin",
    path: "/campaign",
    visibleSidebar: true,
    icon: <Icon as={MdSupervisedUserCircle} w={5} h={5} />,
    component: <Campaign />,
  },
  {
    name: "sideBar.campaignCreate",
    layout: "/admin",
    path: "/campaign/create",
    visibleSidebar: false,
    component: <CampaignCreate />,
  },
  {
    name: "sideBar.campaignUpdate",
    layout: "/admin",
    path: "/campaign/create/:id",
    visibleSidebar: false,
    component: <CampaignCreate />,
  },
  {
    name: "sideBar.news",
    layout: "/admin",
    path: "/news",
    visibleSidebar: true,
    icon: <Icon as={MdSupervisedUserCircle} w={5} h={5} />,
    component: <CampaignNews />,
  },
  {
    name: "sideBar.newsCreate",
    layout: "/admin",
    path: "/news/create",
    visibleSidebar: false,
    component: <CampaignNewsCreate />,
  },
  {
    name: "sideBar.newsUpdate",
    layout: "/admin",
    path: "/news/create/:id",
    visibleSidebar: false,
    component: <CampaignNewsCreate />,
  },
  {
    name: "sideBar.store",
    layout: "/admin",
    path: "/store",
    visibleSidebar: true,
    icon: <Icon as={MdSupervisedUserCircle} w={5} h={5} />,
    component: <Store />,
  },
  {
    name: "sideBar.storeCreate",
    layout: "/admin",
    path: "/store/create",
    visibleSidebar: false,
    component: <StoreCreate />,
  },
  {
    name: "sideBar.storeUpdate",
    layout: "/admin",
    path: "/store/create/:id",
    visibleSidebar: false,
    component: <StoreCreate />,
  },
  {
    name: "sideBar.contactUs",
    layout: "/admin",
    path: "/contact-us",
    visibleSidebar: true,
    icon: <Icon as={MdSupervisedUserCircle} w={5} h={5} />,
    component: <ContactUs />,
  },
  {
    name: "sideBar.contactUsCreate",
    layout: "/admin",
    path: "/contact-us/create",
    visibleSidebar: false,
    component: <ContactUsCreate />,
  },
  {
    name: "sideBar.contactUsUpdate",
    layout: "/admin",
    path: "/contact-us/create/:id",
    visibleSidebar: false,
    component: <ContactUsCreate />,
  },
  {
    name: "sideBar.userCreate",
    layout: "/admin",
    visibleSidebar: false,
    path: "/user/create",
    component: <UserCreate />,
  },
  {
    name: "sideBar.userUpdate",
    layout: "/admin",
    visibleSidebar: false,
    path: "/user/create/:id",
    component: <UserCreate />,
  },
  {
    name: "sideBar.updatePassword",
    layout: "/admin",
    visibleSidebar: false,
    path: "/update-password",
    icon: <Icon as={MdHome} w={5} h={5} />,
    component: <AccountSettings />,
  },
  // {
  //   name: 'Settings',
  //   layout: '/admin',
  //   path: '/main/account/settings',
  //   exact: false,
  //   component: <AccountSettings />,
  // },
  // --- Dashboards ---
  // {
  //   name: 'Dashboards',
  //   path: '/dashboards',
  //   icon: <Icon as={MdHome} width="20px" height="20px" color="inherit" />,
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Main Dashboard',
  //       layout: '/admin',
  //       path: '/dashboards/default',
  //       component: <DashboardsDefault />,
  //     },
  //     {
  //       name: 'Car Interface',
  //       layout: '/admin',
  //       path: '/dashboards/car-interface',
  //       component: <DashboardsCarInterface />,
  //     },
  //     {
  //       name: 'Smart Home',
  //       layout: '/admin',
  //       path: '/dashboards/smart-home',
  //       component: <DashboardsSmartHome />,
  //     },
  //     {
  //       name: 'RTL',
  //       layout: '/rtl',
  //       path: '/dashboards/rtl',
  //       component: <DashboardsRTLDefault />,
  //     },
  //   ],
  // },
  // // // --- NFTs ---
  // {
  //   name: 'NFTs',
  //   path: '/nfts',
  //   icon: (
  //     <Icon
  //       as={MdOutlineShoppingCart}
  //       width="20px"
  //       height="20px"
  //       color="inherit"
  //     />
  //   ),
  //   collapse: true,
  //   items: [
  //     {
  //       name: 'Marketplace',
  //       layout: '/admin',
  //       path: '/nfts/marketplace',
  //       component: <NFTMarketplace />,
  //       secondary: true,
  //     },
  //     {
  //       name: 'Collection',
  //       layout: '/admin',
  //       path: '/nfts/collection',
  //       component: <NFTCollection />,
  //       secondary: true,
  //     },
  //     {
  //       name: 'NFT Page',
  //       layout: '/admin',
  //       path: '/nfts/page',
  //       component: <NFTPage />,
  //       secondary: true,
  //     },
  //     {
  //       name: 'Profile',
  //       layout: '/admin',
  //       path: '/nfts/profile',
  //       component: <NFTProfile />,
  //       secondary: true,
  //     },
  //   ],
  // },
  // // // --- Main pages ---
  {
    name: "Main Pages",
    path: "/main",
    visibleSidebar: false,
    icon: <Icon as={MdDashboard} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      {
        name: "Account",
        path: "/main/account",
        collapse: true,
        items: [
          {
            name: "Billing",
            layout: "/admin",
            path: "/main/account/billing",
            exact: false,
            component: <AccountBilling />,
          },
          {
            name: "Application",
            layout: "/admin",
            path: "/main/account/application",
            exact: false,
            component: <AccountApplications />,
          },
          {
            name: "Invoice",
            layout: "/admin",
            path: "/main/account/invoice",
            exact: false,
            component: <AccountInvoice />,
          },
          {
            name: "Settings",
            layout: "/admin",
            path: "/main/account/settings",
            exact: false,
            component: <AccountSettings />,
          },
          {
            name: "All Courses",
            layout: "/admin",
            path: "/main/account/all-courses",
            exact: false,
            component: <AccountAllCourses />,
          },
          {
            name: "Course Page",
            layout: "/admin",
            path: "/main/account/course-page",
            exact: false,
            component: <AccountCoursePage />,
          },
        ],
      },
      {
        name: "Ecommerce",
        path: "/main/ecommerce",
        collapse: true,
        items: [
          {
            name: "New Product",
            layout: "/admin",
            path: "/main/ecommerce/new-prodcut",
            exact: false,
            component: <EcommerceNewProduct />,
          },
          {
            name: "Product Overview",
            layout: "/admin",
            path: "/main/ecommerce/product-overview",
            exact: false,
            component: <EcommerceProductOverview />,
          },
          {
            name: "Product Settings",
            layout: "/admin",
            path: "/main/ecommerce/settings",
            exact: false,
            component: <EcommerceProductSettings />,
          },
          {
            name: "Product Page",
            layout: "/admin",
            path: "/main/ecommerce/page-example",
            exact: false,
            component: <EcommerceProductPage />,
          },
          {
            name: "Order List",
            layout: "/admin",
            path: "/main/ecommerce/order-list",
            exact: false,
            component: <EcommerceOrderList />,
          },
          {
            name: "Order Details",
            layout: "/admin",
            path: "/main/ecommerce/order-details",
            exact: false,
            component: <EcommerceOrderDetails />,
          },
          {
            name: "Referrals",
            layout: "/admin",
            path: "/main/ecommerce/referrals",
            exact: false,
            component: <EcommerceReferrals />,
          },
        ],
      },
      {
        name: "Users",
        path: "/main/users",
        collapse: true,
        items: [
          {
            name: "New User",
            layout: "/admin",
            path: "/main/users/new-user",
            exact: false,
            component: <UserNew />,
          },
          {
            name: "Users Overview",
            layout: "/admin",
            path: "/main/users/users-overview",
            exact: false,
            component: <UsersOverview />,
          },
          {
            name: "Users Reports",
            layout: "/admin",
            path: "/main/users/users-reports",
            exact: false,
            component: <UsersReports />,
          },
        ],
      },
      {
        name: "Applications",
        path: "/main/applications",
        collapse: true,
        items: [
          {
            name: "Kanban",
            layout: "/admin",
            path: "/main/applications/kanban",
            exact: false,
            component: <ApplicationsKanban />,
          },
          {
            name: "Data Tables",
            layout: "/admin",
            path: "/main/applications/data-tables",
            exact: false,
            component: <ApplicationsDataTables />,
          },
          {
            name: "Calendar",
            layout: "/admin",
            path: "/main/applications/calendar",
            exact: false,
            component: <ApplicationsCalendar />,
          },
        ],
      },
      {
        name: "Profile",
        path: "/main/profile",
        collapse: true,
        items: [
          {
            name: "Profile Overview",
            layout: "/admin",
            path: "/main/profile/overview",
            exact: false,
            component: <ProfileOverview />,
          },
          {
            name: "Profile Settings",
            layout: "/admin",
            path: "/main/profile/settings",
            exact: false,
            component: <ProfileSettings />,
          },
          {
            name: "News Feed",
            layout: "/admin",
            path: "/main/profile/newsfeed",
            exact: false,
            component: <ProfileNewsfeed />,
          },
        ],
      },
      {
        name: "Others",
        path: "/main/others",
        collapse: true,
        items: [
          {
            name: "Notifications",
            layout: "/admin",
            path: "/main/others/notifications",
            exact: false,
            component: <OthersNotifications />,
          },
          {
            name: "Pricing",
            layout: "/auth",
            path: "/main/others/pricing",
            exact: false,
            component: <OthersPricing />,
          },
          {
            name: "404",
            layout: "/admin",
            path: "/main/others/404",
            exact: false,
            component: <OthersError />,
          },
          {
            name: "Messages",
            layout: "/admin",
            path: "/main/others/messages",
            exact: false,
            component: <Messages />,
          },
        ],
      },
    ],
  },
  // // --- Authentication ---
  {
    name: "Authentication",
    visibleSidebar: false,
    path: "/auth",
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    collapse: true,
    items: [
      // --- Sign In ---
      {
        name: "Sign In",
        path: "/login",
        collapse: true,
        items: [
          {
            name: "Default",
            layout: "/auth",
            path: "/sign-in/default",
            component: <SignInDefault />,
          },
          {
            name: "Centered",
            layout: "/auth",
            path: "/login",
            component: <SignInDefault />,
          },
        ],
      },
      // --- Sign Up ---
      {
        name: "Sign Up",
        path: "/sign-up",
        collapse: true,
        items: [
          {
            name: "Default",
            layout: "/auth",
            path: "/sign-up/default",
            component: <SignUpDefault />,
          },
          {
            name: "Centered",
            layout: "/auth",
            path: "/sign-up/centered",
            component: <SignUpCentered />,
          },
        ],
      },
      // --- Verification ---
      // {
      //   name: "Verification",
      //   path: "/verification",
      //   collapse: true,
      //   items: [
      //     {
      //       name: "Default",
      //       layout: "/auth",
      //       path: "/verification/default",
      //       component: <VerificationDefault />,
      //     },
      //     {
      //       name: "Centered",
      //       layout: "/auth",
      //       path: "/verification/centered",
      //       component: <VerificationCentered />,
      //     },
      //   ],
      // },
      // --- Lock ---
      {
        name: "Lock",
        path: "/lock",
        collapse: true,
        items: [
          {
            name: "Default",
            layout: "/auth",
            path: "/lock/default",
            component: <LockDefault />,
          },
          {
            name: "Centered",
            layout: "/auth",
            path: "/lock/centered",
            component: <LockCentered />,
          },
        ],
      },
      // --- Forgot Password ---
      {
        name: "Forgot Password",
        path: "/forgot-password",
        collapse: true,
        items: [
          {
            name: "Default",
            layout: "/auth",
            path: "/forgot-password/default",
            component: <ForgotPasswordDefault />,
          },
          {
            name: "Centered",
            layout: "/auth",
            path: "/forgot-password/centered",
            component: <ForgotPasswordCentered />,
          },
        ],
      },
    ],
  },
];

const retailerRoutes = [
  {
    name: "sideBar.dashboard",
    layout: "/admin",
    visibleSidebar: true,
    path: "/dashboards",
    icon: <Icon as={MdHome} w={5} h={5} />,
    component: <DashboardsDefault />,
  },
  {
    name: "sideBar.category",
    layout: "/admin",
    path: "/category",
    visibleSidebar: true,
    icon: <Icon as={MdSupervisedUserCircle} w={5} h={5} />,
    component: <RetailerCategory />,
  },
  {
    name: "sideBar.categoryCreate",
    layout: "/admin",
    path: "/category/create",
    visibleSidebar: false,
    component: <RetailerCategoryCreate />,
  },
  {
    name: "sideBar.categoryUpdate",
    layout: "/admin",
    path: "/category/create/:id",
    visibleSidebar: false,
    component: <RetailerCategoryCreate />,
  },

  {
    name: "sideBar.product",
    layout: "/admin",
    path: "/product",
    visibleSidebar: true,
    icon: <Icon as={MdSupervisedUserCircle} w={5} h={5} />,
    component: <RetailerProduct />,
  },
  {
    name: "sideBar.productCreate",
    layout: "/admin",
    path: "/product/create",
    visibleSidebar: false,
    component: <RetailerProductCreate />,
  },
  {
    name: "sideBar.productUpdate",
    layout: "/admin",
    path: "/product/create/:id",
    visibleSidebar: false,
    component: <RetailerProductCreate />,
  },
  {
    name: "sideBar.order",
    layout: "/admin",
    path: "/product/excel-list",
    visibleSidebar: false,
    component: <ExcelList />,
  },
  {
    name: "sideBar.order",
    layout: "/admin",
    path: "/product/excel-list/:id",
    visibleSidebar: false,
    component: <ExcelListDetails />,
  },
  {
    name: "sideBar.shipping",
    layout: "/admin",
    path: "/shipping",
    visibleSidebar: true,
    icon: <Icon as={MdSupervisedUserCircle} w={5} h={5} />,
    component: <Shipping />,
  },
  {
    name: "sideBar.shippingCreate",
    layout: "/admin",
    path: "/shipping/create",
    visibleSidebar: false,
    component: <ShippingCreate />,
  },
  {
    name: "sideBar.shippingUpdate",
    layout: "/admin",
    path: "/shipping/create/:id",
    visibleSidebar: false,
    component: <ShippingCreate />,
  },
  {
    name: "sideBar.order",
    layout: "/admin",
    path: "/order",
    visibleSidebar: true,
    icon: <Icon as={MdSupervisedUserCircle} w={5} h={5} />,
    component: <Order />,
  },
  {
    name: "sideBar.order",
    layout: "/admin",
    path: "/order/create/:id",
    visibleSidebar: false,
    component: <OrderCreate />,
  },

  {
    name: "sideBar.store",
    layout: "/admin",
    path: "/store",
    visibleSidebar: true,
    icon: <Icon as={MdSupervisedUserCircle} w={5} h={5} />,
    component: <Store />,
  },
  {
    name: "sideBar.storeCreate",
    layout: "/admin",
    path: "/store/create",
    visibleSidebar: false,
    component: <StoreCreate />,
  },
  {
    name: "sideBar.storeUpdate",
    layout: "/admin",
    path: "/store/create/:id",
    visibleSidebar: false,
    component: <StoreCreate />,
  },
  {
    name: "sideBar.contactUs",
    layout: "/admin",
    path: "/contact-us",
    visibleSidebar: true,
    icon: <Icon as={MdSupervisedUserCircle} w={5} h={5} />,
    component: <ContactUs />,
  },
  {
    name: "sideBar.contactUsCreate",
    layout: "/admin",
    path: "/contact-us/create",
    visibleSidebar: false,
    component: <ContactUsCreate />,
  },
  {
    name: "sideBar.contactUsUpdate",
    layout: "/admin",
    path: "/contact-us/create/:id",
    visibleSidebar: false,
    component: <ContactUsCreate />,
  },
  {
    name: "sideBar.imageUpload",
    layout: "/admin",
    path: "/image-upload",
    visibleSidebar: true,
    icon: <Icon as={MdSupervisedUserCircle} w={5} h={5} />,
    component: <ImagesUpload />,
  },
  {
    name: "sideBar.retailer",
    layout: "/admin",
    visibleSidebar: true,
    path: "/retailer",
    icon: <Icon as={MdSupervisedUserCircle} w={5} h={5} />,
    component: <Retailer />,
  },
  {
    name: "sideBar.retailerCreate",
    layout: "/admin",
    visibleSidebar: false,
    path: "/retailer/create",
    component: <RetailerCreate />,
  },
  {
    name: "sideBar.retailerUpdate",
    layout: "/admin",
    visibleSidebar: false,
    path: "/retailer/create/:id",
    component: <RetailerCreate />,
  },
];

export default { adminRoutes, retailerRoutes };
